import { render, staticRenderFns } from "./OtpInput.vue?vue&type=template&id=58999ee2&"
import script from "./OtpInput.vue?vue&type=script&lang=js&"
export * from "./OtpInput.vue?vue&type=script&lang=js&"
import style0 from "./OtpInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports